module.exports = {
  SaveProductionChange (entity) {
    return {
      Id: entity.id,
      ContractId: entity.contractId,
      ContractMediaId: entity.contractMediaId,
      OperationId: entity.operationId,
      MediaSeqNo: entity.mediaSeqNo,
      ProductionDate: entity.productionDate,
      ProductionCostType: entity.productionCostType,
      SalesAmount: entity.salesAmount,
      SalesAdminAmount: entity.salesAdminAmount,
      Remark: entity.remark,
    }
  },
  /**
   * 更新上画请求参数
   * @param {Object} entity 实体
   */
  UpdateProductionChangeParam (entity) {
return {
      Id: entity.Id,
      mediaSeqNo: entity.mediaSeqNo,
      contractMediaId: entity.contractMediaId,
      operationId: entity.id,
      productionDate: entity.productionDate,
      productionCostType: entity.productionCostType,
      currency: "",
      remark: entity.remark,
      salesAmount: entity.salesAmount,
      salesAdminAmount: entity.salesAdminAmount,
      contractId: entity.contractId,
    };
  }
}

